import { createContext } from 'react'
import { createContextualCan } from '@casl/react'
import type { AppAbilityProps } from './ability'

export const AbilityContext = createContext<AppAbilityProps>(undefined!)

export const Can = createContextualCan(AbilityContext.Consumer)
